module.exports = __webpack_public_path__ + "img/dark-mud-decal-18.4ad60031.png";